// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_ovF","cls2":"CoScientistLandingPage-cls2_w_e CoScientistLandingPage-cls1_ovF"};